import { render, staticRenderFns } from "./UploadAttachmentDialog.vue?vue&type=template&id=600ffbb7&scoped=true"
import script from "./UploadAttachmentDialog.vue?vue&type=script&lang=js"
export * from "./UploadAttachmentDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadAttachmentDialog.vue?vue&type=style&index=0&id=600ffbb7&scoped=true&lang=less"
import style1 from "./UploadAttachmentDialog.vue?vue&type=style&index=1&id=600ffbb7&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600ffbb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('600ffbb7')) {
      api.createRecord('600ffbb7', component.options)
    } else {
      api.reload('600ffbb7', component.options)
    }
    module.hot.accept("./UploadAttachmentDialog.vue?vue&type=template&id=600ffbb7&scoped=true", function () {
      api.rerender('600ffbb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/UploadAttachmentDialog.vue"
export default component.exports